module.exports = __webpack_public_path__ + "static/media/logo-laboratorio.1257c63b.png";